import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Progress } from '../../../components/ui/progress';
import TimelineItem from './TimelineItem';

const Sidebar = ({ sections, currentSection, readSections, setCurrentSection, progress }) => (
  <div className="w-72 flex-shrink-0 border-r border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <Link 
          to="/history" 
          className="flex items-center text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white mb-4"
        >
          <ChevronLeftIcon className="w-5 h-5 mr-1" />
          Back to History
        </Link>
        <div className="mt-2">
          <Progress value={progress} />
          <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {progress}% complete
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {sections.map((section, index) => (
          <TimelineItem
            key={index}
            title={section.title || `Section ${index + 1}`}
            isCompleted={readSections.includes(index)}
            isActive={currentSection === index}
            onClick={() => setCurrentSection(index)}
          />
        ))}
      </div>
    </div>
  </div>
);

export default Sidebar;
